// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__tAI34","location":"Header_location__3onEw"};